import { render, staticRenderFns } from "./RevenueSharingForm.vue?vue&type=template&id=e2244a74&scoped=true&"
import script from "./RevenueSharingForm.vue?vue&type=script&lang=js&"
export * from "./RevenueSharingForm.vue?vue&type=script&lang=js&"
import style0 from "./RevenueSharingForm.vue?vue&type=style&index=0&id=e2244a74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2244a74",
  null
  
)

export default component.exports